import { AppEntities } from "../../../../config/entities";
import { IListViewField } from "../../../Shared/ILIstViewField";
import { ListView } from "../../../Shared/ListViews/ListView";
import { DocumentListViewToolbar } from "../../../Shared/ListViews/DocumentListViewToolbar";
import { ListviewToolbarMoreActions } from "../../../Shared/ListViews/ListviewToolbarMoreActions";
import { DocumentListViewDefaultToolbarButtons } from "../../../Shared/ListViews/DocumentListViewDefaultToolbarButtons";

const FixedAssetsTakeInAccountsList = () => {
  const fields: IListViewField[] = [];

  return (
    <>
      <ListView fields={fields} entity={AppEntities.FixedAssetsTakeInAccounts} createMoreActions={[]}>
        <DocumentListViewToolbar>
          <DocumentListViewDefaultToolbarButtons />
          <ListviewToolbarMoreActions />
        </DocumentListViewToolbar>
      </ListView>
    </>
  );
};

export default FixedAssetsTakeInAccountsList;
